import React from "react";

// styles
import * as styles from "./Faq.module.css";

const Accordion = props => {
  return (
    <div className="accordion accordion-flush" id="faqAccordion">
      {props.faqDetails.map((item, index) => (
        <div
          key={item.key}
          className={`accordion-item ${styles.accordionItem}`}
        >
          <div
            className="accordion-header accordionHeader"
            id={`heading${item.key}`}
          >
            <button
              className={
                index === 0
                  ? `accordion-button p-0 collapsed ${styles.accordionBtn}`
                  : `accordion-button p-0 collapsed ${styles.accordionBtn}`
              }
              type="button"
              data-bs-toggle={"collapse"}
              data-bs-target={`#collapse${item.key}`}
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`collapse${item.key}`}
              onClick={() =>
                props.handleMixpanelCTA(item.eventName, item.eventDesc)
              }
            >
              <p className={styles.accordionTitle}>{item.title}</p>
            </button>
          </div>
          <div
            id={`collapse${item.key}`}
            className={
              index === 0
                ? "accordion-collapse collapse"
                : "accordion-collapse collapse"
            }
            aria-labelledby={`heading${item.key}`}
            data-bs-parent="#faqAccordion"
          >
            <div>
              <div className="row">
                <div className="col-md-12">
                  <p className={styles.desc}>{item.desc}</p>
                </div>
              </div>
            </div>
          </div>
          {index !== props.faqDetails.length - 1 && (
            <hr className={`${styles.darkHr2}`} />
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
